const CLIENT: string = 'client';
const WORKER: string = 'worker';

export { CLIENT, WORKER };
